import React from "react";
import { List } from "antd";

const SimpleGameRankingList = props => {
  const { data } = props;

  console.log(data);

  return (
    <div
      style={{
        position: "absolute",
        left: 8,
        top: 20,
        border: "1px solid",
        boxSizing: "border-box",
        padding: "0 4px"
      }}
    >
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={item.student.name}
              description={`${item.score}`}
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default SimpleGameRankingList;
